import React from 'react';

import Title from '../../../components/Title';
import Editor from '../../../components/Editor';
import Background from '../../../components/Background';

import style from './style.module.css';

export default function Platform(props) {
    const { details = {} } = props;
    const { platform_icon, title, tag, text } = details;

    return (
        <li>
            <div className={style.top}>
                {
                    platform_icon && (
                        <div className={style.platformIcon}>
                            <Background src={platform_icon} size={'300x300'} />
                        </div>
                    )
                }
                {
                    title && (
                        <div className={style.platformName}>
                            <Title
                                tag={tag}
                                className="fontTeko"
                                transform="textUpperCase"
                            >
                                {title}
                            </Title>
                        </div>
                    )
                }
            </div>
            {
                text && (
                    <div className={style.description}>
                        <Editor text={text} />
                    </div>
                )
            }
        </li>
    )
};